import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { LagerplatzInhalt } from '@softapps/lager/core';
import {
  SOFTLINE_API_EINHEITEN_UMBUCHUNG,
  SOFTLINE_API_EINHEITEN_UMBUCHUNG_VORSCHLAG,
  SOFTLINE_API_LAGERPLATZINHALT_ARTIKEL,
} from '../kommissionierung.api';
import {
  EinheitenUmbuchung,
  EinheitenUmbuchungVorschlag,
} from '../types/einheiten-umbuchung';

@Injectable()
export class StockTransferService {
  private readonly dataAccess = inject(ApiDataAccess);

  async loadStock(
    idartstamm: number,
    idlagerstamm?: number
  ): Promise<LagerplatzInhalt[]> {
    // No payload: HttpDataAccess.get() turns any payload into a POST
    const response = await this.dataAccess.get<ResponseResult<LagerplatzInhalt[] | null>>({
      path: SOFTLINE_API_LAGERPLATZINHALT_ARTIKEL,
      pathParams: { idartstamm },
      queryParams: idlagerstamm ? { idlagerstamm } : undefined,
    });
    return response?.result ?? [];
  }

  async loadProposal(
    body: EinheitenUmbuchungVorschlag
  ): Promise<EinheitenUmbuchungVorschlag> {
    const response = await this.dataAccess.create<
      EinheitenUmbuchungVorschlag,
      ResponseResult<EinheitenUmbuchungVorschlag>
    >({ path: SOFTLINE_API_EINHEITEN_UMBUCHUNG_VORSCHLAG }, body);
    return response.result;
  }

  async book(body: EinheitenUmbuchung): Promise<EinheitenUmbuchung> {
    const response = await this.dataAccess.create<
      EinheitenUmbuchung,
      ResponseResult<EinheitenUmbuchung>
    >({ path: SOFTLINE_API_EINHEITEN_UMBUCHUNG }, body);
    return response.result;
  }
}
